import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useChallengeId } from '../../hooks/challenge/useChallengeId'
import { REST_DAYS_QUERY_KEY, useRestDays } from '../../hooks/restDays/useRestDays'
import { useUser } from '../../hooks/user/useUser'
import RestDay from '../../model/RestDay'
import RestDayLockdownScreen from '../../ui/restDays/RestDayLockdownScreen'
import AppShell from '../../ui/layout/AppShell'
import styles from '../../ui/onboarding/GuardView.module.css'
import LoadingIndicator from '../../ui/util/LoadingIndicator'

export interface RestDayRequiredViewProps {
  children: JSX.Element
}

export default function RestDayRequiredView({ children }: RestDayRequiredViewProps) {
  const { data: user } = useUser()
  const challengeId = useChallengeId()
  const { isActive, activeRestDay, isLoading } = useRestDays()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!isActive || !activeRestDay) return

    const checkExpiration = () => {
      const remaining = RestDay.getTimeRemaining(activeRestDay.endTime)
      if (remaining === 0 && user && challengeId) {
        queryClient.invalidateQueries({ queryKey: REST_DAYS_QUERY_KEY(user.id, challengeId) })
      }
    }

    const interval = setInterval(checkExpiration, 1000)
    return () => clearInterval(interval)
  }, [isActive, activeRestDay, user, challengeId, queryClient])

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <LoadingIndicator />
      </div>
    )
  }

  if (isActive && activeRestDay) {
    return (
      <AppShell>
        <RestDayLockdownScreen restDay={activeRestDay} />
      </AppShell>
    )
  }

  return <>{children}</>
}
